import {ChangeDetectionStrategy, Component, Input, TemplateRef, ViewEncapsulation} from "@angular/core";
import {TableData} from "../../types";

@Component({
  selector: 'int-table-row-td',
  template: `
    <ng-container *ngIf="templates[td.fieldName]; else defaultCell">
      <ng-content *ngTemplateOutlet="templates[td.fieldName];context: {rowData: {row: row, td: td, rowIndex: rowIndex} }"></ng-content>
    </ng-container>
    <ng-template #defaultCell>
      {{ td.content }}
    </ng-template>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None
})
export class IntTableBodyTdComponent {
  @Input() templates: {[key: string]: TemplateRef<any>} = {} as {[key: string]: TemplateRef<any>};
  @Input() td: TableData = {} as TableData;
  @Input() row: any;
  @Input() rowIndex: any;

}
